import {
    AccountingExportIntegrationExportAccountingSoftware,
    AccountingExportIntegrationExportTypes,
} from '@mews-commander/data-access';
import { EnumSelectField } from '@mews-commander/form';
import { FormInputField, lt } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { FieldNames } from './fieldNames';
import { TaxAccountMappingList } from './taxAccountMappingList';

export interface ConfigurationDetailFormProps {
    accountingSystemType: AccountingExportIntegrationExportAccountingSoftware | undefined;
}

export const ConfigurationDetailForm = ({ accountingSystemType }: ConfigurationDetailFormProps) => (
    <Stack vertical spacing="300" phoneOnly={{ spacing: '50' }}>
        <FormInputField name={FieldNames.transferAccountCode} label={lt('TransferAccountCode')} required />
        <FormInputField name={FieldNames.folioBalanceAccountCode} label={lt('GuestLedgerAccountCode')} required />
        <FormInputField name={FieldNames.depositAccountCode} label={lt('DepositAccountCode')} required />
        <FormInputField
            name={FieldNames.accountReceivableAccountCode}
            label={lt('AccountReceivableAccountCode')}
            required
        />
        {accountingSystemType === AccountingExportIntegrationExportAccountingSoftware.Avantage ? (
            <EnumSelectField
                name={FieldNames.accountReceivableExportType}
                label={lt('AccountReceivableExportType')}
                enumClass={AccountingExportIntegrationExportTypes}
                enumPrefix="ExportTypes"
                showEmptyValue
            />
        ) : null}
        <FormInputField
            name={FieldNames.revenueFallbackAccountCode}
            label={lt('AccountingExportConfigurationFallbackAccountRevenue')}
        />
        <FormInputField
            name={FieldNames.paymentFallbackAccountCode}
            label={lt('AccountingExportConfigurationFallbackAccountPayments')}
        />
        <FormInputField
            name={FieldNames.outletBillsFallbackAccountCode}
            label={lt('AccountingExportConfigurationFallbackAccountOutlets')}
        />
        <FormInputField
            name={FieldNames.otherFallbackAccountCode}
            label={lt('AccountingExportConfigurationFallbackAccountOther')}
        />
        {accountingSystemType === AccountingExportIntegrationExportAccountingSoftware.Avantage ? (
            <FormInputField name={FieldNames.companyCode} label={lt('CompanyCode')} />
        ) : null}
        {accountingSystemType === AccountingExportIntegrationExportAccountingSoftware.Avantage ? (
            <FormInputField
                name={FieldNames.distinctionTransaction}
                label={lt('DistinctionTransaction')}
                type="number"
            />
        ) : null}
        <TaxAccountMappingList accountingSystemType={accountingSystemType} />
    </Stack>
);
